import { render, staticRenderFns } from "./noviceGuide.vue?vue&type=template&id=ce5edb4c&scoped=true&"
import script from "./noviceGuide.vue?vue&type=script&lang=js&"
export * from "./noviceGuide.vue?vue&type=script&lang=js&"
import style0 from "./noviceGuide.vue?vue&type=style&index=0&id=ce5edb4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5edb4c",
  null
  
)

export default component.exports